<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Backup Locations</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <router-link :to="{ name:'AdminBARLocationsAdd' }" class="btn btn-success"><i class="fa fa-edit"
                                                                                        aria-hidden="true"></i>
          Add Location
        </router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th class="d-none d-md-table-cell">Path</th>
            <th class="d-none d-md-table-cell">Server</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="backup_location in backup_locations" :key="backup_location.backup_location_id">
            <td>
              {{ backup_location.name }}
            </td>
            <td>
              {{ backup_location.backup_location_type.name }}
            </td>
            <td class="d-none d-md-table-cell">
              {{ backup_location.path }}
            </td>
            <td class="d-none d-md-table-cell">
              {{ backup_location.server }}
            </td>
            <td>
              <div class="dropdown">
                <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <router-link
                    :to="{ name:'AdminBARLocationsEdit', params: { backup_location_id: backup_location.backup_location_id } }"
                    class="dropdown-item"><i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                  </router-link>
                  <a class="dropdown-item" href="#" onclick="return false"
                     @click="deleteBackupLocation(backup_location)"><i
                    class="fa fa-trash fa-fw"
                    aria-hidden="true"></i>&nbsp;Delete</a>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <p>
          <b>Backup Location Recommended Naming Conventions</b>
        </p>
        <p>
          Location names may contain upper and lower-case text and spaces. Maintaining lower case naming conventions is
          recommended.
        </p>
        Examples:
        <ul>
          <li>Network --> network bu</li>
          <li>Local --> local bu</li>
          <li>FTP -- > ftp bu</li>
          <li>PBIP FTP -- > phx ftp bu</li>
        </ul>
        <p>
          <b>Folder Recommended Naming Conventions</b>
        </p>
        <p>
          School Initials - phx-bu (Do not use spaces)
        </p>
        Example:
        <ul>
          <li>Acme Elementary ac-phx-bu</li>
        </ul>
        <p>
          NOTE: Do not use spaces. Do not use special characters. Maintain lower case naming conventions. Use - or _ to
          separate words.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: mapGetters({
    backup_locations: 'allBackupLocations'
  }),
  created () {
    this.$store.dispatch('getBackupLocations')
  },
  methods: {
    ...mapActions([
      'deleteBackupLocation'
    ])
  }
}
</script>

<style scoped>

</style>
